module.exports = __webpack_public_path__ + "static/media/07․05.8da3d187.webp";